import { Box } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import MonthlyCostPerOsaChart from '../components/MonthlyCostPerOsaChart'
import MonthlyRatingChart from '../components/MonthlyRatingChart'
import { ReportRefreshButton } from '../components/ReportRefreshButton'
import ScoutOsaCountChart from '../components/ScoutOsaCountChart'

export const ScoutReportTab: React.FC = () => {
  const queryClient = useQueryClient()

  const handleRefresh = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ['analytics'] }),
    [queryClient]
  )

  return (
    <>
      <ReportRefreshButton onRefresh={handleRefresh} />
      <Box>
        <ScoutOsaCountChart />
      </Box>
      <Box sx={{ mt: 3 }}>
        <MonthlyCostPerOsaChart env="live" />
      </Box>
      <Box sx={{ mt: 3 }}>
        <MonthlyRatingChart env="live" />
      </Box>
    </>
  )
}
